{
  "pwa": {
    "addToHomeScreenDescription": "Add SAP storefront to your device homescreen for a faster return visit",
    "noInstallationNeeded": "No installation needed",
    "fastAccessToApplication": "Fast access to application",
    "addToHomeScreen": "Add to home screen",
    "addedToHomeScreen": "SAP Storefront was added to your home screen"
  }
}